import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/openbook",
  },
  {
    path: "/openbook",
    name: "openbook",
    component: Home,
    meta: {
      title: ["开业手册"],
    },
  },
  {
    path: "/open",
    name: "open",
    component: () => import("../views/Open/Open.vue"),
    meta: {
      title: ["开业申请", "我要开业"],
    },
  },
  {
    path: "/openlist",
    name: "openlist",
    component: () => import("../views/Open/List.vue"),
    meta: {
      title: ["开业申请", "申请列表"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/processlist",
    name: "list",
    component: () => import("../views/Process/List.vue"),
    meta: {
      title: ["开业流程", "流程列表"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/process",
    name: "process",
    component: () => import("../views/Process/Process.vue"),
    children: [
      {
        path: "financial",
        name: "financial",
        component: () => import("../views/Process/Financial.vue"),
        meta: {
          title: ["流程节点", "财务预算及借款"],
        },
      },
      {
        path: "location",
        name: "location",
        component: () => import("../views/Process/Location.vue"),
        meta: {
          title: ["流程节点", "选址及房屋租赁"],
        },
      },
      {
        path: "registered",
        name: "registered",
        component: () => import("../views/Process/Registered.vue"),
        meta: {
          title: ["流程节点", "开设系统账号"],
        },
      },
      {
        path: "business",
        name: "business",
        component: () => import("../views/Process/Business/index.vue"),
        meta: {
          title: ["流程节点", "工商注册及备案"],
        },
      },
      {
        path: "bank",
        name: "bank",
        component: () => import("../views/Process/Bank/index.vue"),
        meta: {
          title: ["流程节点", "工商注册及备案"],
        },
      },
      {
        path: "accountApply",
        name: "accountApply",
        component: () => import("../views/Process/AccountApply.vue"),
        meta: {
          title: ["流程节点", "账套编号申请"],
        },
      },
      {
        path: "employee",
        name: "employee",
        component: () =>
          import("../views/Process/EmployeeTransferApply/index.vue"),
        meta: {
          title: ["流程节点", "工商注册及备案"],
        },
      },
      {
        path: "opening",
        name: "opening",
        component: () => import("../views/Process/Opening/index.vue"),
        meta: {
          title: ["流程节点", "工商注册及备案"],
        },
      },

      //todo：待补充完成所有路由
    ],
  },
  {
    path: "/signsure",
    name: "signsure",
    component: () => import("../views/Approve/Signsure.vue"),
    meta: {
      title: ["审批", "待审批"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/signsure/detail",
    name: "signsuredetail",
    component: () => import("../views/Approve/SignsureDetail.vue"),
  },
  {
    path: "/signconting",
    name: "signconting",
    component: () => import("../views/Approve/Signconting.vue"),
    meta: {
      title: ["审批", "已审批"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/signlaunch",
    name: "signlaunch",
    component: () => import("../views/Approve/Signlaunch.vue"),
    meta: {
      title: ["审批", "我发起的"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/signcopy",
    name: "signcopy",
    component: () => import("../views/Approve/Signcopy.vue"),
    meta: {
      title: ["审批", "抄送我的"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/changelist",
    name: "changelist",
    component: () => import("../views/Change/List.vue"),
    meta: {
      title: ["工商变更", "列表"],
      keepAlive: true,
      flag: true,
    },
  },
  {
    path: "/change",
    name: "change",
    component: () => import("../views/Change/Form/Business.vue"),
    meta: {
      title: ["工商变更", "提交申请"],
    },
  },
  {
    path: "/changeProcess",
    name: "changeProcess",
    component: () => import("../views/Change/Process.vue"),
    meta: {
      title: ["工商变更", "提交申请"],
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export default router;
